export function isValidPackagingQuantity(value: string, max: number): boolean {
  const quantity = Number(value);
  return /^\d+$/.test(value) && Number.isInteger(quantity) && quantity >= 1 && quantity <= max;
}
